import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function ContentLoaderComponent__svg_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "animate", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("values", ctx_r0.animationValues[0])("dur", ctx_r0.speed);
} }
function ContentLoaderComponent__svg_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "animate", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("values", ctx_r1.animationValues[1])("dur", ctx_r1.speed);
} }
function ContentLoaderComponent__svg_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "animate", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("values", ctx_r2.animationValues[2])("dur", ctx_r2.speed);
} }
const _c0 = ["*"];
function uid() {
    return Math.random()
        .toString(36)
        .substring(2);
}
class ContentLoaderComponent {
    constructor() {
        this.animate = true;
        this.baseUrl = '';
        this.width = 400;
        this.height = 130;
        this.speed = 2;
        this.preserveAspectRatio = 'xMidYMid meet';
        this.primaryColor = '#f9f9f9';
        this.secondaryColor = '#ecebeb';
        this.primaryOpacity = 1;
        this.secondaryOpacity = 1;
        this.idClip = uid();
        this.idGradient = uid();
        this.defautlAnimation = ['-3; 1', '-2; 2', '-1; 3'];
        this.rtlAnimation = ['1; -3', '2; -2', '3; -1'];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.animationValues = this.rtl ? this.rtlAnimation : this.defautlAnimation;
    }
    /**
     * @return {?}
     */
    get fillStyle() {
        return {
            fill: `url(${this.baseUrl}#${this.idGradient})`
        };
    }
    /**
     * @return {?}
     */
    get clipStyle() {
        return `url(${this.baseUrl}#${this.idClip})`;
    }
}
ContentLoaderComponent.ɵfac = function ContentLoaderComponent_Factory(t) { return new (t || ContentLoaderComponent)(); };
ContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ContentLoaderComponent, selectors: [["content-loader"]], inputs: { animate: "animate", baseUrl: "baseUrl", width: "width", height: "height", speed: "speed", preserveAspectRatio: "preserveAspectRatio", primaryColor: "primaryColor", secondaryColor: "secondaryColor", primaryOpacity: "primaryOpacity", secondaryOpacity: "secondaryOpacity", uniqueKey: "uniqueKey", rtl: "rtl", style: "style" }, ngContentSelectors: _c0, decls: 12, vars: 19, consts: [[3, "ngStyle"], ["x", "0", "y", "0", 3, "ngStyle"], ["offset", "0%"], [4, "ngIf"], ["offset", "50%"], ["offset", "100%"], ["attributeName", "offset", "s", "", "repeatCount", "indefinite"]], template: function ContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "rect", 1);
        ɵngcc0.ɵɵelementStart(2, "defs")(3, "clipPath");
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "linearGradient")(6, "stop", 2);
        ɵngcc0.ɵɵtemplate(7, ContentLoaderComponent__svg_ng_container_7_Template, 2, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "stop", 4);
        ɵngcc0.ɵɵtemplate(9, ContentLoaderComponent__svg_ng_container_9_Template, 2, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "stop", 5);
        ɵngcc0.ɵɵtemplate(11, ContentLoaderComponent__svg_ng_container_11_Template, 2, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵattributeInterpolate2("viewBox", "0 0 ", ctx.width, " ", ctx.height, "");
        ɵngcc0.ɵɵproperty("ngStyle", ctx.style);
        ɵngcc0.ɵɵattribute("preserveAspectRatio", ctx.preserveAspectRatio);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.fillStyle);
        ɵngcc0.ɵɵattribute("clip-path", ctx.clipStyle)("width", ctx.width)("height", ctx.height);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.idClip);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.idGradient);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stop-color", ctx.primaryColor)("stop-opacity", ctx.primaryOpacity);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.animate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stop-color", ctx.secondaryColor)("stop-opacity", ctx.secondaryOpacity);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.animate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stop-color", ctx.primaryColor)("stop-opacity", ctx.primaryOpacity);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.animate);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgStyle], encapsulation: 2 });
ContentLoaderComponent.propDecorators = {
    animate: [{ type: Input }],
    baseUrl: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    speed: [{ type: Input }],
    preserveAspectRatio: [{ type: Input }],
    primaryColor: [{ type: Input }],
    secondaryColor: [{ type: Input }],
    primaryOpacity: [{ type: Input }],
    secondaryOpacity: [{ type: Input }],
    uniqueKey: [{ type: Input }],
    rtl: [{ type: Input }],
    style: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'content-loader',
                template: "<svg attr.viewBox=\"0 0 {{width}} {{height}}\" [attr.preserveAspectRatio]=\"preserveAspectRatio\" [ngStyle]=\"style\">\n\n  <rect [attr.clip-path]=\"clipStyle\" [ngStyle]=\"fillStyle\" x=\"0\" y=\"0\" [attr.width]=\"width\" [attr.height]=\"height\" />\n\n  <defs>\n\n    <clipPath [attr.id]=\"idClip\">\n      <ng-content></ng-content>\n    </clipPath>\n\n    <linearGradient [attr.id]=\"idGradient\">\n\n      <stop offset=\"0%\" [attr.stop-color]=\"primaryColor\" [attr.stop-opacity]=\"primaryOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[0]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\n        </ng-container>\n      </stop>\n\n      <stop offset=\"50%\" [attr.stop-color]=\"secondaryColor\" [attr.stop-opacity]=\"secondaryOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[1]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\n        </ng-container>\n      </stop>\n\n      <stop offset=\"100%\" [attr.stop-color]=\"primaryColor\" [attr.stop-opacity]=\"primaryOpacity\">\n        <ng-container *ngIf=\"animate\">\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[2]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\n        </ng-container>\n      </stop>\n\n    </linearGradient>\n\n  </defs>\n\n</svg>\n"
            }]
    }], function () { return []; }, { animate: [{
            type: Input
        }], baseUrl: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], speed: [{
            type: Input
        }], preserveAspectRatio: [{
            type: Input
        }], primaryColor: [{
            type: Input
        }], secondaryColor: [{
            type: Input
        }], primaryOpacity: [{
            type: Input
        }], secondaryOpacity: [{
            type: Input
        }], uniqueKey: [{
            type: Input
        }], rtl: [{
            type: Input
        }], style: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class BulletListContentLoaderComponent extends ContentLoaderComponent {
}
BulletListContentLoaderComponent.ɵfac = /*@__PURE__*/ function () { let ɵBulletListContentLoaderComponent_BaseFactory; return function BulletListContentLoaderComponent_Factory(t) { return (ɵBulletListContentLoaderComponent_BaseFactory || (ɵBulletListContentLoaderComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(BulletListContentLoaderComponent)))(t || BulletListContentLoaderComponent); }; }();
BulletListContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BulletListContentLoaderComponent, selectors: [["bullet-list-content-loader"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 10, consts: [[3, "animate", "width", "height", "speed", "preserveAspectRatio", "primaryColor", "secondaryColor", "primaryOpacity", "uniqueKey"], ["cx", "10", "cy", "20", "r", "8"], ["x", "25", "y", "15", "rx", "5", "ry", "5", "width", "220", "height", "10"], ["cx", "10", "cy", "50", "r", "8"], ["x", "25", "y", "45", "rx", "5", "ry", "5", "width", "220", "height", "10"], ["cx", "10", "cy", "80", "r", "8"], ["x", "25", "y", "75", "rx", "5", "ry", "5", "width", "220", "height", "10"], ["cx", "10", "cy", "110", "r", "8"], ["x", "25", "y", "105", "rx", "5", "ry", "5", "width", "220", "height", "10"]], template: function BulletListContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "content-loader", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(1, "circle", 1)(2, "rect", 2)(3, "circle", 3)(4, "rect", 4)(5, "circle", 5)(6, "rect", 6)(7, "circle", 7)(8, "rect", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("animate", ctx.animate)("width", ctx.width)("height", ctx.height)("speed", ctx.speed)("preserveAspectRatio", ctx.preserveAspectRatio)("primaryColor", ctx.primaryColor)("secondaryColor", ctx.secondaryColor)("primaryOpacity", ctx.primaryOpacity)("secondaryColor", ctx.secondaryColor)("uniqueKey", ctx.uniqueKey);
    } }, dependencies: [ContentLoaderComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BulletListContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'bullet-list-content-loader',
                template: `
  <content-loader [animate]="animate" [width]="width" [height]="height" [speed]="speed" [preserveAspectRatio]="preserveAspectRatio"
  [primaryColor]="primaryColor" [secondaryColor]="secondaryColor" [primaryOpacity]="primaryOpacity" [secondaryColor]="secondaryColor"
  [uniqueKey]="uniqueKey">
    <svg:circle cx="10" cy="20" r="8" />
    <svg:rect x="25" y="15" rx="5" ry="5" width="220" height="10" />
    <svg:circle cx="10" cy="50" r="8" />
    <svg:rect x="25" y="45" rx="5" ry="5" width="220" height="10" />
    <svg:circle cx="10" cy="80" r="8" />
    <svg:rect x="25" y="75" rx="5" ry="5" width="220" height="10" />
    <svg:circle cx="10" cy="110" r="8" />
    <svg:rect x="25" y="105" rx="5" ry="5" width="220" height="10" />
   </content-loader>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FacebookContentLoaderComponent extends ContentLoaderComponent {
}
FacebookContentLoaderComponent.ɵfac = /*@__PURE__*/ function () { let ɵFacebookContentLoaderComponent_BaseFactory; return function FacebookContentLoaderComponent_Factory(t) { return (ɵFacebookContentLoaderComponent_BaseFactory || (ɵFacebookContentLoaderComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(FacebookContentLoaderComponent)))(t || FacebookContentLoaderComponent); }; }();
FacebookContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FacebookContentLoaderComponent, selectors: [["facebook-content-loader"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 10, consts: [[3, "animate", "width", "height", "speed", "preserveAspectRatio", "primaryColor", "secondaryColor", "primaryOpacity", "uniqueKey"], ["x", "70", "y", "15", "rx", "4", "ry", "4", "width", "117", "height", "6.4"], ["x", "70", "y", "35", "rx", "3", "ry", "3", "width", "85", "height", "6.4"], ["x", "0", "y", "80", "rx", "3", "ry", "3", "width", "350", "height", "6.4"], ["x", "0", "y", "100", "rx", "3", "ry", "3", "width", "380", "height", "6.4"], ["x", "0", "y", "120", "rx", "3", "ry", "3", "width", "201", "height", "6.4"], ["cx", "30", "cy", "30", "r", "30"]], template: function FacebookContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "content-loader", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(1, "rect", 1)(2, "rect", 2)(3, "rect", 3)(4, "rect", 4)(5, "rect", 5)(6, "circle", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("animate", ctx.animate)("width", ctx.width)("height", ctx.height)("speed", ctx.speed)("preserveAspectRatio", ctx.preserveAspectRatio)("primaryColor", ctx.primaryColor)("secondaryColor", ctx.secondaryColor)("primaryOpacity", ctx.primaryOpacity)("secondaryColor", ctx.secondaryColor)("uniqueKey", ctx.uniqueKey);
    } }, dependencies: [ContentLoaderComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FacebookContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'facebook-content-loader',
                template: `
  <content-loader [animate]="animate" [width]="width" [height]="height" [speed]="speed" [preserveAspectRatio]="preserveAspectRatio"
  [primaryColor]="primaryColor" [secondaryColor]="secondaryColor" [primaryOpacity]="primaryOpacity" [secondaryColor]="secondaryColor"
  [uniqueKey]="uniqueKey">
  	<svg:rect x="70" y="15" rx="4" ry="4" width="117" height="6.4" />
  	<svg:rect x="70" y="35" rx="3" ry="3" width="85" height="6.4" />
  	<svg:rect x="0" y="80" rx="3" ry="3" width="350" height="6.4" />
  	<svg:rect x="0" y="100" rx="3" ry="3" width="380" height="6.4" />
  	<svg:rect x="0" y="120" rx="3" ry="3" width="201" height="6.4" />
  	<svg:circle cx="30" cy="30" r="30" />
   </content-loader>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ListContentLoaderComponent extends ContentLoaderComponent {
}
ListContentLoaderComponent.ɵfac = /*@__PURE__*/ function () { let ɵListContentLoaderComponent_BaseFactory; return function ListContentLoaderComponent_Factory(t) { return (ɵListContentLoaderComponent_BaseFactory || (ɵListContentLoaderComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(ListContentLoaderComponent)))(t || ListContentLoaderComponent); }; }();
ListContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListContentLoaderComponent, selectors: [["list-content-loader"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 10, consts: [[3, "animate", "width", "height", "speed", "preserveAspectRatio", "primaryColor", "secondaryColor", "primaryOpacity", "uniqueKey"], ["x", "0", "y", "0", "rx", "3", "ry", "3", "width", "250", "height", "10"], ["x", "20", "y", "20", "rx", "3", "ry", "3", "width", "220", "height", "10"], ["x", "20", "y", "40", "rx", "3", "ry", "3", "width", "170", "height", "10"], ["x", "0", "y", "60", "rx", "3", "ry", "3", "width", "250", "height", "10"], ["x", "20", "y", "80", "rx", "3", "ry", "3", "width", "200", "height", "10"], ["x", "20", "y", "100", "rx", "3", "ry", "3", "width", "80", "height", "10"]], template: function ListContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "content-loader", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelement(1, "rect", 1)(2, "rect", 2)(3, "rect", 3)(4, "rect", 4)(5, "rect", 5)(6, "rect", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("animate", ctx.animate)("width", ctx.width)("height", ctx.height)("speed", ctx.speed)("preserveAspectRatio", ctx.preserveAspectRatio)("primaryColor", ctx.primaryColor)("secondaryColor", ctx.secondaryColor)("primaryOpacity", ctx.primaryOpacity)("secondaryColor", ctx.secondaryColor)("uniqueKey", ctx.uniqueKey);
    } }, dependencies: [ContentLoaderComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'list-content-loader',
                template: `
  <content-loader [animate]="animate" [width]="width" [height]="height" [speed]="speed" [preserveAspectRatio]="preserveAspectRatio"
  [primaryColor]="primaryColor" [secondaryColor]="secondaryColor" [primaryOpacity]="primaryOpacity" [secondaryColor]="secondaryColor"
  [uniqueKey]="uniqueKey">
  	<svg:rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
  	<svg:rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
  	<svg:rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
  	<svg:rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
  	<svg:rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
  	<svg:rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
   </content-loader>
  `
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ContentLoaderModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: ContentLoaderModule
        };
    }
}
ContentLoaderModule.ɵfac = function ContentLoaderModule_Factory(t) { return new (t || ContentLoaderModule)(); };
ContentLoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ContentLoaderModule });
ContentLoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentLoaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    ContentLoaderComponent,
                    FacebookContentLoaderComponent,
                    BulletListContentLoaderComponent,
                    ListContentLoaderComponent
                ],
                exports: [
                    ContentLoaderComponent,
                    FacebookContentLoaderComponent,
                    BulletListContentLoaderComponent,
                    ListContentLoaderComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ContentLoaderModule, { declarations: function () { return [ContentLoaderComponent, FacebookContentLoaderComponent, BulletListContentLoaderComponent, ListContentLoaderComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ContentLoaderComponent, FacebookContentLoaderComponent, BulletListContentLoaderComponent, ListContentLoaderComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ContentLoaderComponent, ContentLoaderModule, FacebookContentLoaderComponent, ListContentLoaderComponent, BulletListContentLoaderComponent };

